import { useEffect, useState } from 'react';

const matchesViewport = (breakpoint) => (
  typeof window !== 'undefined'
  && window.matchMedia(`(max-width: ${breakpoint}px)`).matches
);

const useMobileViewport = (breakpoint) => {
  const [isMobile, setIsMobile] = useState(() => matchesViewport(breakpoint));

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const media = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handleChange = (event) => setIsMobile(event.matches);
    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, [breakpoint]);

  return isMobile;
};

export default useMobileViewport;
